module.exports = __webpack_public_path__ + "aecbc53ebc8e41c323ebfeb9e7fe0096.pdf";